import script from "./LinkedAccountsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkedAccountsTab.vue?vue&type=script&setup=true&lang=js"

import "./LinkedAccountsTab.vue?vue&type=style&index=0&id=270b975c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270b975c"]])

export default __exports__